angular.module(NgAppName).component('crSaveToProfile', {
	templateUrl: 'crSaveToProfile.html',
	transclude: true,
	bindings: {
		objToSave: '<',
		type: '@',
		isMobile: '<',
		forListing: '<',
		hideSaveTooltip: '<',
		hideBtnOnSave: '<',
		rpcSaveToProfile: '@',
		rpcDeleteToProfile: '@',
		hrefSavedBuildings: '@',
		portfolioDirection: '@',
		tooltip2Lines: '<',
		listingId: '@',
		requestMethod: '@',
		updateSavedApts: '<',
		onUpdateListingPortfolio: '&',
		sourceType: '@',
		orgn: '@',
		withLottie: '<',
		linkIconClass: '@',
		hiddenObjWrapper: '<'
	},
	controller: ['$element', '$timeout', '$transclude', '$http', '$window', '$q', 'PubSub', 'crResourcesService', function($element, $timeout, $transclude, $http, $window, $q, PubSub, crResourcesService) {
		var deferredAbort;
		var ctrl = this;
		if (!ctrl.linkIconClass) {
			ctrl.linkIconClass = 'link-icon';
		}
		if (ctrl.withLottie) {
			ctrl.heartAnimation = { "nm": "Love 2", "ddd": 0, "h": 34, "w": 34, "meta": { "g": "@lottiefiles/toolkit-js 0.33.2" }, "layers": [{ "ty": 4, "nm": "Stroke Outlines", "sr": 1, "st": 0, "op": 30, "ip": 0, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 0, "k": 100, "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 2, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[-0.001, 13.816], [-0.001, -5.575]] }, "ix": 2 } }, { "ty": "st", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Stroke", "nm": "Stroke 1", "lc": 1, "lj": 1, "ml": 10, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 1, "ix": 5 }, "c": { "a": 0, "k": [1, 0.2431, 0.4549], "ix": 3 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }, { "ty": "tm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Trim", "nm": "Trim Paths 1", "ix": 2, "e": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 10 }, { "s": [100], "t": 26 }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "s": { "a": 0, "k": 0, "ix": 1 }, "m": 1 }], "ind": 1 }, { "ty": 4, "nm": "Stroke Outlines 2", "sr": 1, "st": 0, "op": 10, "ip": 0, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [100], "t": 0 }, { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [100], "t": 8 }, { "s": [0], "t": 10 }], "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 2, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[-0.001, 13.816], [-0.001, -5.575]] }, "ix": 2 } }, { "ty": "st", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Stroke", "nm": "Stroke 1", "lc": 1, "lj": 1, "ml": 10, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 1, "ix": 5 }, "c": { "a": 0, "k": [1, 0.2431, 0.4549], "ix": 3 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }], "ind": 2 }, { "ty": 4, "nm": "Fill Outlines", "sr": 1, "st": 0, "op": 45, "ip": 26, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0, 0, 100], "t": 26 }, { "s": [100, 100, 100], "t": 30 }], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 0, "k": 100, "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 3, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[0, 13.816], [0, -5.575]] }, "ix": 2 } }, { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 4 }, { "ty": "fl", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Fill", "nm": "Fill 1", "c": { "a": 0, "k": [1, 0.2431, 0.4549], "ix": 4 }, "r": 1, "o": { "a": 0, "k": 100, "ix": 5 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }], "ind": 3 }], "v": "4.12.0", "fr": 15, "op": 45, "ip": 0, "assets": [] };
		}
		this.isGuest = G;
		this.sharedToAgents = [];
		this.displayPortfolio = false;
		this.animation = null;

		// this is need for the old apartment table from mootools widget that comes from the rpc.
		// this is being used in tableTools.js
		$element[0].isCompiled = true;

		this.uuid = Core.uuid();

		this.initializeLottieAnimation = function() {
			if (ctrl.withLottie) {
				$timeout(function() {
					let lottie_elements = $element[0].getElementsByClassName('lottie-container');
					if (lottie_elements && lottie_elements.length > 0) {
						if (ctrl.animation) {
							ctrl.animation.destroy();
						}
						ctrl.animation = lottie.loadAnimation({
							container: lottie_elements[0],
							renderer: 'svg',
							loop: true,
							autoplay: true,
							animationData: ctrl.heartAnimation
						});
					}
				});
			}
		};
		
		this.saveMouseOver = function($event) {
			var saveDeleteStatus = 0;
			if (!this.isGuest) {
				saveDeleteStatus = ctrl.objToSave.saveDeleteStatus;
			}
			if (!!ctrl.orgn && saveDeleteStatus != '-1') {
				if (ctrl.canUseSaveFlag() === true) {
					var saveFlag = angular.element(document.querySelector('.save-flag'));
					if (!!saveFlag) {
						ctrl.isSaveFlagOver = true;
					}
					if (ctrl.canUseSmallText() === true) {
						ctrl.isSmallText = true;
					}
				} else {
					var saveFlag2 = angular.element(document.querySelector('.save-flag2'));
					if (!!saveFlag2) {
						ctrl.isSaveFlag2Over = true;
					}
					if (ctrl.canUseUp() === true) {
						ctrl.isUp = true;
					}
				}
			}
		};

		this.saveMouseLeave = function($event) {
			if (!!ctrl.orgn) {
				if (ctrl.canUseSaveFlag() === true) {
					var saveFlag = angular.element(document.querySelector('.save-flag'));
					if (!!saveFlag) {
						ctrl.isSaveFlagOver = false;
					}
				} else {
					var saveFlag2 = angular.element(document.querySelector('.save-flag2'));
					if (!!saveFlag2) {
						ctrl.isSaveFlag2Over = false;
					}
				}
			}

			if (!ctrl.displayPortfolio) {
				let _bodyId = angular.element(document.body).attr('id');
				let _elementId = $element.attr('id');
				if (!!_bodyId && _bodyId == 'lst' && !!_elementId && _elementId == 'stalker-lst-save-btn') {
					let _stalkerPersistNav = angular.element(document.getElement('.w_stalker .persist_nav'));
					if (!!_stalkerPersistNav) {
						_stalkerPersistNav.css({'overflow': 'hidden'});
					}
				}
			}
		};

		this.canUseSaveFlag = function() {
			switch (ctrl.orgn) {
				case 'buildingOptionsFull':
				case 'listingOptionsFull':
				case 'similarBuildings':
				case 'similarApartments':
				case 'listingTitle':
					return true;

				default:
					return false;

			}
		};

		this.canUseSmallText = function() {
			if (!!ctrl.orgn && ctrl.orgn == 'listingTitle' && !!ctrl.type && ctrl.type == 'map' && !!ctrl.sourceType && ctrl.sourceType == 'listing') {
				return true;
			} else {
				return false;
			}
		};

		this.canUseUp = function() {
			if (!!ctrl.forListing && !!ctrl.objToSave && !!ctrl.objToSave.portfolioList && !!ctrl.objToSave.portfolioList.length && ctrl.objToSave.portfolioList.length > 1) {
				return true;
			} else {
				return false;
			}
		}

		// add Sign up event
		if (!this.isMobile && this.isGuest) {
			Core.add_signup_link($($element[0]));
			ctrl.initializeLottieAnimation();
			return;
		}

		if (this.isMobile) {
			if (this.listingId) {
				this.btnFave = angular.element(document.querySelector('.btn-listing-' + this.listingId));
			} else {
				this.btnFave = angular.element(document.querySelector('.btn-icon.btn-fave, .cr-clustermap-panel-btn-fave')) || angular.element(document.querySelector('.cr-clustermap-panel-btn-fave'));
			}
		}

		this.$postLink = function () {
			if (this.hiddenObjWrapper) {
				this.objToSave = this.hiddenObjWrapper;
			} else {
				var hiddenObject = angular.element($element[0].getElementsByClassName('obj-wrapper'));//angular.element(document.querySelector('.obj-wrapper'));
				if (hiddenObject && hiddenObject.html()) {
					this.objToSave = JSON.parse(hiddenObject.html());
					hiddenObject.remove();
				}
			}

			if (this.objToSave) {

				$element[0].objToSave = this.objToSave;

				if (this.objToSave.saveDeleteStatus && typeof(this.objToSave.saveDeleteStatus) === 'string') {
					this.objToSave.saveDeleteStatus = parseInt(this.objToSave.saveDeleteStatus);
				}

				if (this.forListing) {
					// get the portfolio for the listing
					this.objToSave.portfolioList = this.objToSave.portfolioList || angular.copy(crUser.getPortfolio());

					angular.forEach(ctrl.objToSave.portfolioList, function(agent) {
						// need to split the token the private option could have 2 tokens[sale/rent] together seperated by '-'
						angular.forEach(agent.token.split('-'), function(token) {
							if (ctrl.objToSave.portfolio && ctrl.objToSave.portfolio.indexOf(token) > -1) {
								agent.shared = true;
							}
						});
					});

					PubSub.subscribe('updateListing-'+this.objToSave.listing_id, function(listing) {
						if (listing) {
							ctrl.objToSave.portfolio = listing.portfolio;
							ctrl.objToSave.portfolioList = listing.portfolioList;
							ctrl.objToSave.saveDeleteStatus = listing.saveDeleteStatus;
						}
					});
				} else {

					PubSub.subscribe('updateBuilding-'+this.objToSave.id, function(building) {
						if (building) {
							ctrl.objToSave.saveDeleteStatus = building.saveDeleteStatus;
							if (building.saveDeleteStatus === 0) {
								ctrl.objToSave.showTooltip = building.showTooltip;
							}
						}
					});
				}
			}
			
			if (this.objToSave) {
				$element[0].setAttribute('data-obj-to-save', JSON.stringify(this.objToSave));
			}
			
			ctrl.initializeLottieAnimation();

		};

		this.showPortfolio = function($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}

			// Directly save to the default (first) portfolio
			if (ctrl.objToSave.portfolioList && ctrl.objToSave.portfolioList.length > 0) {
				ctrl.updatePortfolio(ctrl.objToSave.portfolioList[0]);
			}
		};

		this.updatePortfolio = function(agent, $event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}

			// Ensure portfolio array exists
			if (!ctrl.objToSave.portfolio) {
				ctrl.objToSave.portfolio = [];
			}

			let tokenFound = false;

			// Check if any part of the agent's token is already in the portfolio
			angular.forEach(agent.token.split('-'), function(token) {
				if (ctrl.objToSave.portfolio.indexOf(token) > -1) {
					tokenFound = true;
				}
			});

			if (tokenFound || ctrl.objToSave.portfolio.indexOf(agent.token) > -1) {
				// Remove full token or any matching part
				ctrl.objToSave.portfolio = ctrl.objToSave.portfolio.filter(function(token) {
					return agent.token.split('-').indexOf(token) === -1 && token !== agent.token;
				});
				agent.shared = false; // Update shared flag
			} else {
				// Add the agent's full token
				ctrl.objToSave.portfolio = [agent.token];
				agent.shared = true;
			}

			// Call save function immediately
			ctrl.saveToProfile($event, agent);
		};

		this.saveToProfile = function($event, agent) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}

			var url = this.rpcSaveToProfile ? this.rpcSaveToProfile : this.objToSave.urls ? this.objToSave.urls.saveToProfile : null;
			// for now on similar building section in the building page, since we dont hide the save icon for the save building,
			// and user try to click it, it will redirect to the saved building page.
			if (!this.forListing && this.objToSave.saveDeleteStatus === -1) {
				url = this.rpcDeleteToProfile ? this.rpcDeleteToProfile : this.objToSave.urls ? this.objToSave.urls.deleteToProfile : null;
			}

			// save the listing in specific portfolio
			angular.forEach(this.objToSave.portfolioList, function(agent) {
				// FML, can you name variables reasonably, please?
				// It took some debugging to figure out that 'age' actually means 'agent'. Are 2 saved characters really worth the confusion?
				// Updated.
				if (agent.shared) {
					url += '&p[]=' + agent.token;
				}
			});

			if (this.request) {
				this.request.$cancelRequest();
			}

			if (this.requestMethod === 'get') {
				this.request = crResourcesService.get(url);
			} else {
				this.request = crResourcesService.post2(url, {});
			}

			this.request.$promise.then(function(data) {
				if (data.status) {
					ctrl.success = true;
					if (!ctrl.forListing) {
						// Set to unsaved status after unsaving the building
						if (ctrl.objToSave.saveDeleteStatus === -1) {
							ctrl.objToSave.saveDeleteStatus = 0;
							ctrl.objToSave.showTooltip = 0;
							ctrl.updateBuildingStatus(ctrl.objToSave);
							ctrl.initializeLottieAnimation();
							return;
						}

						// only for List view on Search result page, since we only diplay the links on mouseover,
						// i append the message to the hidden td element to Keep the message open.
						var id = ctrl.objToSave.mask_id || ctrl.objToSave.id;
						var parentRow = angular.element(document.querySelector('.save_message_container._' + id));

						if (parentRow.length) {
							var wrapper = parentRow.find('div');
							var element = wrapper[0].querySelector('.success_message');
							// if the success message is not already there then add it to the wrapper (resolve the multiple click issue)
							if (!element) {
								var successMsg = angular.element(document.querySelector('.success_message._' + id));
								if (successMsg.length) {
									angular.element(wrapper).append(successMsg);
								}
							}
						}

						// close it after 5seconds
						ctrl.objToSave.showTooltip = 1;
						ctrl.objToSave.saveDeleteStatus = -1;// saved
						ctrl.updateBuildingStatus(ctrl.objToSave);

						$timeout(function() {
							ctrl.objToSave.showTooltip = 0;// hide tooltip in 5 sec
						}, 50000);
					} else {
						ctrl.objToSave.saveDeleteStatus = -1;// saved
						// set the status to 0 to show the unsaved heart icon
						if (!ctrl.objToSave.portfolio.length) {
							ctrl.objToSave.saveDeleteStatus = 0;
						}

						// Update the save button of the listing on mobile
						if (ctrl.isMobile) {
							ctrl.updateSaveBtnMobile();
						}

						// execute the method from the parent
						// to do update the portfolio of the same listing from different widget after saving or unsaving the listing.
						ctrl.updateListingPortfolio(agent);
					}
					ctrl.initializeLottieAnimation();
				}
			}, function errorCallback(response) {
				// todo: manage error
			});
		};

		this.closeSuccessMessage = function($event) {
			if ($event) {
				$event.stopPropagation();
			}

			if (this.hideBtnOnSave) {
				this.hide = true;
			} else {
				this.objToSave.showTooltip = 0;
				this.objToSave.saveDeleteStatus = -1;// saved
			}
		};

		this.updateListingPortfolio = function(agent) {
			// update the portfolio of the same listing from different widget
			PubSub.publish('updateListing-'+ctrl.objToSave.listing_id, ctrl.objToSave);

			this.onUpdateListingPortfolio({
				listingId: ctrl.objToSave.listing_id,
				agent: agent
			});
		};

		this.updateBuildingStatus = function(building) {
			PubSub.publish('updateBuilding-' + ctrl.objToSave.id, ctrl.objToSave);
		};

		this.updateSaveBtnMobile = function() {
			if (!this.objToSave.portfolio.length) {
				this.btnFave.removeClass('_active');
			} else {
				this.btnFave.addClass('_active');
			}
		};
	}]
});
